import {Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',

})
export class AppComponent {
  constructor(
  ){}
  // @HostListener("window:beforeunload",["$event"])
  // clearLocalStorage(event:any){
  //     localStorage.clear();
  // }
}
